import { defineNuxtRouteMiddleware } from 'nuxt/app'

import { isCoursesAnnouncementsRoutePath } from '../utils/announcements-route.utils'
import { isCPAuthRoutePath } from '../utils/auth-route.utils'
import { isCrossingCommunitiesGroupsUsersLayout } from '../utils/communities-layout-route.utils'

/**
 * Auth routes own a full-screen layout. Disable transitions at this boundary so
 * Nuxt does not retain the previous layout wrapper while auth content enters.
 *
 * Communities group ↔ user profile layouts swap wrappers. Disable transitions at
 * that boundary so out-in layout leave does not strand the old layout in
 * layout-leave-active while the URL already points at the target.
 *
 * Courses announcements list/detail disable transitions at the boundary so SPA
 * navigation from chrome outside NuxtPage (top bar) does not hit out-in
 * `insertBefore` failures that leave the previous page mounted.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const isEnteringOrLeavingAuth = isCPAuthRoutePath(to.path) !== isCPAuthRoutePath(from.path)
  const isCrossingCommunitiesProfileLayout = isCrossingCommunitiesGroupsUsersLayout(from.path, to.path)
  const isEnteringOrLeavingAnnouncements = isCoursesAnnouncementsRoutePath(to.path) !== isCoursesAnnouncementsRoutePath(from.path)

  if (isEnteringOrLeavingAuth || isCrossingCommunitiesProfileLayout || isEnteringOrLeavingAnnouncements) {
    to.meta.layoutTransition = false
    to.meta.pageTransition = false
  }
})
